import { render, staticRenderFns } from "./RecursosCP.vue?vue&type=template&id=51f05def"
import script from "./RecursosCP.vue?vue&type=script&lang=js"
export * from "./RecursosCP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports